import { Component, OnInit, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CandidateService } from 'src/app/shared/candidate.service';
import { NotificationService } from 'src/app/shared/notification.service';
import { Candidate } from 'src/app/model/candidate.model';
import { DatePipe } from '@angular/common';
import { MatRadioChange, MatRadioButton, MatSelectChange, MatSelectionList, MatSelect } from '@angular/material';


interface AttemptStatus {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-candidate',
  templateUrl: './candidate.component.html',
  styleUrls: ['./candidate.component.scss']
})
export class CandidateComponent implements OnInit {

  datePipe = new DatePipe("en-US");
  updateCandiateList = new EventEmitter();

  maxDate: Date;

  constructor(public service: CandidateService,
    public notificationService: NotificationService,
    public dialogRef: MatDialogRef<CandidateComponent>
    ) { 
      this.maxDate = new Date();
    }

  ngOnInit() {
  }

  genderChanged(mrChange: MatRadioChange) {
    let mrButton: MatRadioButton = mrChange.source;
  }

  attemptStatusChanged(msChange: MatSelectChange) {
    let msSelect: MatSelect = msChange.source;
  }

  onSubmit() {
    if (this.service.form.valid) {
      let candidateName = this.service.form.value.candidateName;
      let gender = this.service.form.value.gender;
      let email = this.service.form.value.email;
      let contactNo = this.service.form.value.contactNo;
      let address = this.service.form.value.address;
      let dob = this.service.form.value.dob;
      dob = this.datePipe.transform(dob, 'yyyy-MM-dd');
      let totalMarks = this.service.form.value.totalMarks;
      let score = this.service.form.value.score;
      let attemptStatus = this.service.form.value.attemptStatus;
      let candidate = new Candidate(candidateName, gender, email, contactNo, address, dob, totalMarks, score, attemptStatus, null);
      if (this.service.form.value.id == null) {
        this.service.createCandidate([candidate]).then(
          res => {
            try {
              const { listOfRejectedCandidates, listOfSavedCandidates, message } = res && res.data;
              this.notificationService.success(message || 'Successfully created');
              this.updateCandiateList.emit(listOfSavedCandidates);
            } catch (error) {
              this.updateCandiateList.emit(error);
            }
            this.onClose();
          },
          err => {
            const { data, errors } = err;
            const { listOfRejectedCandidates } = data;

            errors.forEach(errorObj => {
              const { message } = errorObj;
              this.notificationService.warn(message || 'Failed to upload');
            });
            
            listOfRejectedCandidates.forEach(candidateObj => {
              candidateObj.listOfErrorMessageAssociated.forEach(errorMessage => {
                this.notificationService.warn(errorMessage);
              })
            });
            return false;
          }
        );
      } else {
        this.service.updateCandidate(candidate, this.service.form.value.id)
            .then(res => {
              try {
                this.updateCandiateList.emit(res); 
                this.notificationService.success('Successfully updated');
                this.onClose();
              } catch (error) {
                this.updateCandiateList.emit(error);
                this.notificationService.warn('Failed to update');
                this.onClose();
              }
            }).catch(err => {
              try {
                const { errors } = err;
                errors.forEach(error => {
                  const { message } = error;
                  this.notificationService.warn(message);
                });
              } catch (error) {
                const errMessage = typeof err === 'string' ? err : 'Failed to update';
                this.notificationService.warn(errMessage);
                console.error(error);
              }
            });
      }
    }
  }

  onClose() {
    this.service.form.reset();
    this.dialogRef.close();
  }

  onClear() {
    this.service.form.reset();
    this.notificationService.success('Cleared');
  }

}
